import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1.7fr 1fr;
  height: 100%;
  width: 100%;
  background-color: #e5e5e5;

  @media (min-width: 320px) and (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;

export const Right = styled.div`
  margin-top: -70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 15%;
  padding-left: 10%;
  overflow-y: auto;
  justify-content: center;

  #fbh-logo {
    width: 35%;
    object-fit: contain;
    margin: 50px 0px;
    /* background-color: red; */
  }

  button {
    width: 100%;
    margin: 20px 0px;
  }

  .MuiInputBase-root {
    // Margem entre os inputs do formulário
    & + .MuiInputBase-root {
      margin-top: 5px;
    }
  }

  @media (min-width: 320px) and (max-width: 960px) {
    padding: 0px 25px;
    margin-top: -210px;

    #fbh-logo {
      width: 47%;
    }
  }
`;

export const Left = styled.div`
  background-color: #fff;
  align-items: center;
  justify-content: center;
  display: flex;

  /* background: linear-gradient(
    -80deg,
    #e5e5e5 0%,
    #e5e5e5,
    15%,
    white 15%,
    white 100%
  ); */

  /* background: linear-gradient(-85deg, #e5e5e5 7%, white -5%); */

  overflow: hidden;
  position: relative;

  :before {
    content: '';
    font-family: 'shape divider from ShapeDividers.com';
    position: absolute;
    z-index: 3;
    pointer-events: none;
    background-repeat: no-repeat;
    bottom: -0.1vw;
    left: -0.1vw;
    right: -2vw;
    top: -0.1vw;
    background-size: 190px 220%;
    background-position: 100% 100%;
    background-image: url('data:image/svg+xml;charset=utf8, <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76.2 381" preserveAspectRatio="none"><g fill="%23e5e5e5"><path d="M0 381l8.47-12.7c8.46-12.7 25.4-38.1 28.23-63.5 2.72-25.4-8.39-50.8-5.66-76.2 2.83-25.4 19.76-50.8 18.36-76.2-1.51-25.4-21.09-50.8-28.23-76.2-7.15-25.4-1.33-50.8 1.4-63.5L25.4 0h50.8v381z"/><path d="M8.47 381l4.23-12.7c4.23-12.7 12.7-38.1 12.7-63.5s-8.47-50.8-7.06-76.2c1.5-25.4 12.62-50.8 11.3-76.2C28.3 127 14.01 101.6 8.46 76.2 2.9 50.8 5.56 25.4 7.07 12.7L8.46 0H76.2v381z" opacity=".66"/></g></svg>');
  }

  #clickhemofilia-logo {
    width: 55%;
    margin-bottom: 40px;
    margin-right: 125px;
    /* background-color: red; */
    object-fit: contain;
  }

  @media (min-width: 320px) and (max-width: 960px) {
    display: none;
  }
`;

export const Title = styled.h2`
  color: #373737;
  font-weight: 600;
  margin-bottom: 25px;
`;
